import { Switch, Redirect } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import ErrorRoute from './ErrorRoute';
import { UserTypology } from 'helpers/Enums';

import {
    Homepage,
    NewTicket,
    Tickets,
    TicketDetails,
    TicketInbox,
    Scheduling,
    Absences,
    AbsenceDetails,
    Error403, 
    Error404,
    Tools,
    ToolDetails,
    ToolEdit,
    Customers,
    Customer,
    CustomersSummary
} from 'views';
import {
    TicketCategories,
    TicketCategoryDetails,
    Users,
    User,
    UserGroups,
    ToolTypologies,
    ToolTypologyDetails
} from 'views/Admin';
import {
    CustomerNewTicket,
    CustomerTicketDetails,
    CustomerTickets,
    CustomerUsers,
    CustomerUser
} from 'views/CustomerViews';


let Routes = () => {
    return (
        <Switch>
            <PrivateRoute enableUserTypes={[UserTypology.Simec, UserTypology.Customer]} exact path="/" component={Homepage} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/ticket/addnew" component={NewTicket} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/tickets" component={Tickets} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/ticket/edit/:id" component={TicketDetails} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/tickets/inbox" component={TicketInbox} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/ticket/addnewfrommessage/:id/:customer" component={NewTicket} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/ticketcategories" component={TicketCategories} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/ticketcategory/addnew" component={TicketCategoryDetails} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/ticketcategory/edit/:id" component={TicketCategoryDetails} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/users" component={Users} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/user/edit/:id" component={User} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/user/addnew/" component={User} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/usergroups" component={UserGroups} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/customers" component={Customers} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/customer/edit/:id" component={Customer} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/customer/addnew/" component={Customer} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/absences" component={Absences} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/absence/edit/:id" component={AbsenceDetails} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/absence/addnew/" component={AbsenceDetails} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/tooltypologies" component={ToolTypologies} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/tooltypology/edit/:id" component={ToolTypologyDetails} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/tooltypology/addnew/" component={ToolTypologyDetails} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/tools" component={Tools} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/tool/edit/:id" component={ToolEdit} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/tool/addnew/" component={ToolEdit} />
            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/tool/:id" component={ToolDetails} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/scheduling" component={Scheduling} />

            <PrivateRoute enableUserTypes={[UserTypology.Simec]} exact path="/customerssummary" component={CustomersSummary} />

            <PrivateRoute enableUserTypes={[UserTypology.Customer]} exact path="/customer/ticket/addnew" component={CustomerNewTicket} />
            <PrivateRoute enableUserTypes={[UserTypology.Customer]} exact path="/customer/tickets" component={CustomerTickets} />
            <PrivateRoute enableUserTypes={[UserTypology.Customer]} exact path="/customer/ticket/edit/:id" component={CustomerTicketDetails} />

            <PrivateRoute enableUserTypes={[UserTypology.Customer]} exact path="/customer/users" component={CustomerUsers} />
            <PrivateRoute enableUserTypes={[UserTypology.Customer]} exact path="/customer/user/edit/:id" component={CustomerUser} />
            <PrivateRoute enableUserTypes={[UserTypology.Customer]} exact path="/customer/user/addnew/" component={CustomerUser} />

            <ErrorRoute exact path="/error403" component={Error403} />
            <ErrorRoute exact path="/error404" component={Error404} />

            <Redirect to="/error404" />
        </Switch>
    )
}

export default Routes;